export {data};

import API_URL from '../../includes/api.js';
import {resolveTenantData} from '../../tenant/site-configs.js';
import {fetchApiJson, refererHeaders} from '../../includes/server-fetch.js';

// Mirrors Search's mount-time fetch (same default sort as its initial sortOption state).
// Keeps the results grid populated at render instead of empty until the client fetch completes.
//
// +data.shared.js is NOT cumulative in Vike — this file fully replaces the root +data.shared.js.
// Must resolve+spread tenant data itself or this page loses messages/faq/about.
async function data(pageContext) {
    const tenantData = resolveTenantData(pageContext);
    const search = pageContext.urlParsed?.search ?? {};
    const q = search.q ?? '';
    const type = search.type ?? '';

    // Search's client-side fetch still runs after hydration and will retry
    // if this fails or the user changes the sort option.
    const result = await fetchApiJson(`${API_URL}/song/search?s=${encodeURIComponent(q)}&orderBy=title&orderDir=ASC&type=${encodeURIComponent(type)}`, refererHeaders(pageContext), pageContext);
    return {...tenantData, songs: result.ok ? (result.data ?? []) : null};
}
